import { connect } from "react-redux";
import HubspotConfigurationView from "./HubspotConfigurationView.jsx";
import { deleteCustomFields, fetchCustomFields, fetchHubspotIntegration, fetchOpportunityFields, saveOpportunityFields, syncOpportunityFields } from "src/legacy/redux/actions/integrations.jsx";
import { updateConfiguration, overridePrimaryConfiguration, deleteSecondaryConfiguration } from "src/legacy/redux/actions/integrations/hubspot.jsx";
import _ from "lodash";
import HubspotFunctionalWrapper from "./HubspotFunctionalWrapper.js";

const mapStateToProps = (state, ownProps) => {
  return {
    loading: _.get(state.legacyRootReducer.settings, "integrations.hubspot.config.loading"),
    integration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration"),
    primaryIntegration: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.primaryIntegration"),
    secondaryInstance: _.get(state.legacyRootReducer.settings, "integrations.hubspot.integration.configuration"),
    updating: _.get(state.legacyRootReducer.settings, "integrations.hubspot.changes.saving"),
    deactivating:  _.get(state.legacyRootReducer.settings, "integrations.hubspot.deactivation.deactivating"),
    error: _.get(state.legacyRootReducer.settings, "integrations.hubspot.changes.error"),
    authenticating: _.get(state.legacyRootReducer.settings , "integrations.hubspot.authentication.authenticating"),
    user: state.users.me,
    opportunityFields: _.get(state,"legacyRootReducer.settings.integrations.activated.opportunityFields.items"),
    customFields: _.get(state,"legacyRootReducer.settings.integrations.activated.customFields.items"),
    loadingFields: _.get(state,"legacyRootReducer.settings.integrations.activated.opportunityFields.loading"),
    isCustomFieldsLoading: _.get(state,"legacyRootReducer.settings.integrations.activated.customFields.loading"),
    hubspotPipelines: ownProps.hubspotPipelines,
    isHubspotPipelinesLoading: ownProps.isHubspotPipelinesLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    },
    overridePrimaryConfiguration: (configuration, id) => {
      return dispatch (overridePrimaryConfiguration(configuration, id));
    },

    deleteSecondaryConfiguration: (id) => {
      return dispatch(deleteSecondaryConfiguration(id));
    },

    fetchHubspotIntegration: () => {
      return dispatch(fetchHubspotIntegration());
    },

    fetchCustomFields: (id) => {
      return dispatch(fetchCustomFields(id));
    },

    fetchOpportunityFields: (id, filters) => {
      return dispatch(fetchOpportunityFields(id, filters));
    },

    saveOpportunityFields: (id, fields) => {
      return dispatch(saveOpportunityFields(id, fields));
    },

    syncOpportunityFields: (id) => {
      return dispatch(syncOpportunityFields(id));
    },
    deleteCustomFields: (id, customFieldIds) => {
      return dispatch(deleteCustomFields(id, customFieldIds));
    },

  };
};

const HubspotConfigurationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(HubspotConfigurationView);

export default HubspotFunctionalWrapper(HubspotConfigurationPage);
